import { setAppLoading, setAppStateMessage } from "./app";
import axios from '../../axios';
import { getVehicles } from "./vehicles";

export const changeAppointment = (appointmentId, action, cb) => {
    return async (dispatch, getState) => {
        dispatch(setAppLoading(true));

        const onError = (err) => {
            dispatch(setAppLoading(false));
            dispatch(setAppStateMessage({type: 'error', msg: err }))
            cb && cb(err, null);
        };

        const token = getState().auth.token.id_token;
        try {
            const res = await axios.post(`/appointment/change-request`, {
                id: appointmentId,
                action: action
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            });
            if (res.data && res.data.error) {
                throw new Error(res.data.error);
            }

            dispatch(setAppLoading(false));
            dispatch(setAppStateMessage({ type: 'success', msg: 'The appointment changes has been submitted' }));
            cb && cb(null, res);
        } catch(err) {
            console.log('err', err);
            onError(err.message);
        }
    }
};